(function() {
    angular
        .module("app")
        .factory("eventsService", eventsService)

    eventsService.$inject = ["$rootScope", "$http"]

    function eventsService($rootScope, $http) {
        var service = {}

        /**
            Get all events
            @param {int} messageBoardID
            @returns {*}
         **/
        service.getEvents = function(messageBoardID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/events"
            }).then(getEventsComplete, getEventsFailed)

            function getEventsComplete(response) {
                return response.data
            }

            function getEventsFailed(error) {
                console.error(error)
            }
        }

        /**
            Get single event
            @param {int} messageBoardID
            @param {int} eventID
            @returns {*}
         **/
        service.getEvent = function(messageBoardID, eventID) {
            return $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/events/" + eventID
            }).then(getEventComplete, getEventFailed)

            function getEventComplete(response) {
                return response.data
            }

            function getEventFailed(error) {
                console.error(error)
            }
        }

        /**
            Create new event
            @param {int} messageBoardID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.createEvent = function(messageBoardID, formData, successCallback, failureCallback) {
            console.log("Create Event Form Data: ", formData)

            return $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/events",
                data: formData
            }).then(createEventComplete, createEventFailed)

            function createEventComplete(response) {
                successCallback(response.data)
                return response.data
            }

            function createEventFailed(error) {
                var error_messages = ""

                if(error.data.errors.base) {
                    angular.forEach(error.data.errors.base, function(value, key) {
                        error_messages += value + ". "
                    })
                }
                if(error.data.errors.start_message) {
                    angular.forEach(error.data.errors.start_message, function(value, key) {
                        error_messages += "Start message " + value + ". "
                    })
                }
                if(error.data.errors.end_message) {
                    angular.forEach(error.data.errors.end_message, function(value, key) {
                        error_messages += "End message " + value + ". "
                    })
                }

                failureCallback(error_messages)

                console.error(error)
            }
        }

        /**
            Edit existing event
            @param {int} messageBoardID
            @param {int} eventID
            @param formData
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.editEvent = function(messageBoardID, eventID, formData, successCallback, failureCallback) {
            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/events/" + eventID,
                data: formData
            }).then(editEventComplete, editEventFailed)

            function editEventComplete(response) {
                successCallback()
                return response.data
            }

            function editEventFailed(error) {
                var error_messages = ""

                if(error.data.errors.base) {
                    angular.forEach(error.data.errors.base, function(value, key) {
                        error_messages += value + ". "
                    })
                }
                if(error.data.errors.start_message) {
                    angular.forEach(error.data.errors.start_message, function(value, key) {
                        error_messages += "Start message " + value + ". "
                    })
                }
                if(error.data.errors.end_message) {
                    angular.forEach(error.data.errors.end_message, function(value, key) {
                        error_messages += "End message " + value + ". "
                    })
                }

                failureCallback(error_messages)

                console.error(error)
            }
        }

        /**
            Delete existing event
            @param {int} messageBoardID
            @param {int} eventID
            @param successCallback
            @param failureCallback
            @returns {*}
         **/
        service.deleteEvent = function(messageBoardID, eventID, successCallback, failureCallback) {
            return $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/message_boards/" + messageBoardID + "/events/" + eventID
            }).then(deleteEventComplete, deleteEventFailed)

            function deleteEventComplete(response) {
                successCallback()
                return response.data
            }

            function deleteEventFailed(error) {
                console.error(error)
                failureCallback(error)
            }
        }

        return service
    }
})()
